@if (showIconBtnVariant) {
  <ng-container *ngTemplateOutlet="iconBtnTemplate"></ng-container>
} @else {
  <div class="share-btn" (click)="openPopup($event)">
    <div
      class="btv-icon-share"
      [ngClass]="{
        'theme-beats__shareBeatIcon': parentComponent === 'track-item',
        'theme-player__shareBeatIcon': parentComponent === 'player',
        'theme-beats__dropdownControlsIcons': parentComponent === 'track-mob-controls'
      }"
    ></div>
    @if (parentComponent === 'track-mob-controls') {
      <p class="share-btn__title theme-beats__dropdownControlsIcons">
        {{ lg.tracksBlock.shareDrop }}
      </p>
    }
  </div>
}

<ng-template #iconBtnTemplate>
  <bmcore-button (clickHandler)="openPopup($event)" [styleName]="getIconBtnVariant()">
    <bmcore-share-icon [width]="iconSize" [height]="iconSize"></bmcore-share-icon>
  </bmcore-button>
</ng-template>
